/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebRedirectInputModel
 */
export interface FrontWebRedirectInputModel {
    /**
     * Old path
     * @type {string}
     * @memberof FrontWebRedirectInputModel
     */
    oldPath: string;
}

/**
 * Check if a given object implements the FrontWebRedirectInputModel interface.
 */
export function instanceOfFrontWebRedirectInputModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "oldPath" in value;

    return isInstance;
}

export function FrontWebRedirectInputModelFromJSON(json: any): FrontWebRedirectInputModel {
    return FrontWebRedirectInputModelFromJSONTyped(json, false);
}

export function FrontWebRedirectInputModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebRedirectInputModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'oldPath': json['oldPath'],
    };
}

export function FrontWebRedirectInputModelToJSON(value?: FrontWebRedirectInputModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'oldPath': value.oldPath,
    };
}

